import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Citadelgames cut our campaign waste by 62%. We finally launch when the frost actually hits, not when the calendar says so.',
  author: 'Eirlys Valtonen',
  role: 'Head of Seasonal Growth',
  company: 'Nordvik Outerwear'
}, {
  quote: 'The Meridian Scheduler alone saved us €34,000 in Q4 by aligning our heating campaign across Baltic markets.',
  author: 'Seren Kask',
  role: 'Marketing Director',
  company: 'Halvard Energy'
}, {
  quote: 'We went from guessing snow seasons to owning them. Our ski package conversions tripled.',
  author: 'Caius Mäkelä',
  role: 'VP of Digital',
  company: 'Ísfjord Travel'
}];
export function Testimonials() {
  return <section id="solutions" className="py-24 px-6 relative z-10 bg-navy-light/20" data-id="element-139">
      <div className="container mx-auto max-w-7xl" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-142">
            Trusted by Seasonal Strategists
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto text-lg" data-id="element-143">
            See how leading cold-weather brands are transforming their marketing
            ROI with weather-triggered automation.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-144">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-panel p-8 rounded-2xl flex flex-col justify-between" data-id="element-145">
              <div className="mb-8" data-id="element-146">
                <div className="flex gap-1 mb-6" data-id="element-147">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-ice" fill="currentColor" viewBox="0 0 20 20" data-id="element-148">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-149" />
                    </svg>)}
                </div>
                <p className="text-white/90 text-lg leading-relaxed font-medium italic" data-id="element-150">
                  "{testimonial.quote}"
                </p>
              </div>

              <div data-id="element-151">
                <div className="font-semibold text-frost" data-id="element-152">
                  {testimonial.author}
                </div>
                <div className="text-white/50 text-sm" data-id="element-153">
                  {testimonial.role}, {testimonial.company}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}